import * as React from "react";
import { InputField } from "../components/InputField.tsx";
import { Slide } from "@mui/material";
import { setLaborCost, setClientCosts } from "../Store/roiStore.ts";
import { useSelector, useStore } from "react-redux";
import { useConfig } from "../hooks/useConfig.ts";
import { useEffect } from "react";
import { getTotal } from "../utils/index.ts";
import "../styles/pages/supply-chain-costs.scss";

const headers = [
  " ",
  "Hourly Rate",
  "Benefits",
];

const tableHeader = (
  <>
    {headers.map((header) => (
      <div className="tableHeader">{header}</div>
    ))}
  </>
);

export const SupplyChainCosts = () => {
  const config = useConfig();
  const configData = config.inputFields.laborCost;
  const clientCostsConfig = config.inputFields.clientCosts;
  const laborcost = useSelector((state) => state.inputFields.laborCost);
  const clientCosts = useSelector((state) => state.inputFields.clientCosts);
  const { dispatch } = useStore();
  const spendDetailsDataFromStore = useSelector(
    (state) => state.inputFields.spendDetailsRows
  );

  useEffect(() => {
    dispatch(
      setLaborCost({
        subValue: "Benefits",
        name: "Lead",
        value: laborcost["Inventory Tech"]?.["Benefits"] ?? 0,
      })
    );
    dispatch(
      setLaborCost({
        subValue: "Benefits",
        name: "Supervisor",
        value: laborcost["Inventory Tech"]?.["Benefits"] ?? 0,
      })
    );
  }, [laborcost["Inventory Tech"]?.["Benefits"]]);

  return (
    <Slide direction="right" in={true} mountOnEnter unmountOnExit>
      <div className="supply-chain-costs-page">
        <h1>Client's Current & Future Costs</h1>

        <h3 className="labor-rates-heading">Supply Chain Labor Rates</h3>
        <div>
          <div className="labor-rates-grid">
            {tableHeader}
            {Array.from({ length: 9 }, (_, index) => {
              const currentCell = configData[index];
              return currentCell.customText ? (
                  <div key={index}>{currentCell.customText}</div>
              ) : (
                <InputField
                  key={index}
                  placeholder={currentCell.placeholder}
                  value={laborcost?.[currentCell?.name]?.[currentCell?.header]}
                  onValueInputChange={(name, value) =>
                    dispatch(
                      setLaborCost({
                        subValue: configData[index]?.header,
                        name: configData[index]?.name ?? "",
                        value: value,
                      })
                    )
                  }
                  {...(currentCell.hiddenLabel && {
                    hiddenLabel: currentCell.hiddenLabel,
                  })}
                  {...(currentCell.prefix && { prefix: currentCell.prefix })}
                  {...(currentCell.suffix && { suffix: currentCell.suffix })}
                  {...(currentCell.type && { type: currentCell.type })}
                  {...(currentCell.hidden && { hidden: currentCell.hidden })}
                  {...(currentCell.disabled && {
                    disabled: currentCell.disabled,
                  })}
                  {...(currentCell.defaultValue && {
                    defaultValue: currentCell.defaultValue,
                  })}
                />
              );
            })}
          </div>
        </div>
        <h3 className="idn-costs-heading">IDN-wide Cost & Activity Assumptions</h3>
        <div className="idn-costs-grid">
          {clientCostsConfig.map((field) => {
            const label = field.displayLabel ?? field.label;
            return (
              <React.Fragment key={field.label}>
                <div className="idn-costs-label">
                  {label}
                </div>
                <InputField
                  placeholder={field.placeholder}
                  value={clientCosts?.[field.label] ?? field.defaultValue}
                  helperText={field.smallNote ?? ""}
                  onValueInputChange={(name, value) =>
                    dispatch(
                      setClientCosts({
                        name: field.label,
                        value: value,
                      })
                    )
                  }
                  {...(field.prefix && { prefix: field.prefix })}
                  {...(field.suffix && { suffix: field.suffix })}
                  {...(field.type && { type: field.type })}
                  {...(field.defaultValue && {
                    defaultValue: field.defaultValue,
                  })}
                />
              </React.Fragment>
            );
          })}
        </div>
        <div className="idn-costs-notes">
          <div>#1 - Annual price increases of medical supplies from 2021-2024 averaged 6%; Definitive Healthcare; 2025.</div>
          <div>#2 - Medical supply expiration rates range from 5% (best in class) to 8-10% for typical patient care areas; in procedural areas product expiration rates are typically 5-8%.</div>
          <div>#3 - Valera Health Study, 2023; GHX, 2024 - Overstock rates typically exceed 20% for patient care areas and can be as high as 30% or more in procedural departments.</div>
        </div>
      </div>
    </Slide>
  );
};
